import _ from 'underscore';
import Backbone from 'backbone';
import moment from 'moment';


export default Backbone.Model.extend({
  url: MESSAGE_API_URL,
  idAttribute: 'url',
  default_img: STATIC_URL + 'img/mh-' + GLOBALS.BRANDING + '.png',

  numerical_id: function () {
    var split = this.get('url').split('/');
    return split[split.length - 2];
  },
  list_image: function () {
    return this.author_image('list');
  },
  full_image: function () {
    return this.author_image('full');
  },
  author_image: function (image_type) {
    if (this.get('author_images')) {
      return this.get('author_images')[image_type];
    }
    return this.default_img;

  },
  format_datetime: function () {
    return moment(this.get('timestamp')).format('MMM D, h:mm a');
  },
  has_photo: function () {
    var category = this.get('category');
    return category == 'message' || category == 'appointment-reject' && this.get('body');
  },
  has_icon: function () {
    var categories = [ 'reminder', 'alert', 'appointment-request', 'appointment-reminder',
      'authorized-welcome' ];
    return _.contains(categories, this.get('category'));
  },
  from_me: function () {
    return _.contains(this.get('classes'), 'is-from-me');
  },
  author_name: function () {
    return this.from_me() ? 'You' : this.escape('author_name');
  },
  recip_name: function () {
    return this.from_me() ? this.escape('recipient_name') : 'you';
  },
  appt_coach_name: function () {
    return _.escape(this.get('appointment').them.name);
  },
  appt_datetime: function () {
    return moment(this.get('appointment').start).format('ddd MMM D, h:mm a');
  },
  appt_coach_list_image: function () {
    if (this.get('appointment') && this.get('appointment').them.images) {
      return this.get('appointment').them.images.list;
    }
    return this.default_img;

  },
  status: function () {
    return _.escape(this.get('appointment').status);
  },
  pretty_status: function () {
    var status = this.status();
    if (status == 'pending') {
      return 'Request sent';
    } else if (status == 'rejected') {
      return 'Declined';
    } else if (status == 'needs-action') {
      return 'Needs action';
    }
    // Capitalize first letter
    return status.charAt(0).toUpperCase() + status.slice(1);

  },
  article_classes: function () {
    var classes = 'type-' + this.get('category');
    if (this.get('appointment')) {
      classes = classes + ' clickable';
    }
    if (this.has_photo() || this.has_icon()) {
      classes = classes + ' has_icon';
    }
    return classes;
  }

});



// WEBPACK FOOTER //
// ./static/js/models/message.js